import {useTranslation} from "react-i18next";
import React from "react";

import {NavbarProps} from "./Navbar.types";
import "./Navbar.scss";

import LogoutIcon from './../../../assets/images/sidebaricons/logouticonactive.svg'; /* Todo: maybe the icon should be copied to the local dir? */

export const Navbar: React.FC<NavbarProps> = ({userName, userAvatar, status, languageSelectorComponent, onPressUser}) => {
    const { t } = useTranslation();

    return (
        <div className="navbar">
            <div className="d-flex align-items-center">
                <button 
                    className="navbar-logout btn btn-link"
                    onClick={() => {
                        //@ts-ignore
                        document.getElementById("logout-btn").click()
                    }}
                >
                    {t("log_out_text")}
                    <img src={LogoutIcon}/>
                </button>
            </div>
            <div className="user-info">
                <div onClick={() => onPressUser ? onPressUser() : null} className={'user'}>
                    <div className="user-block">
                        <span className="user-name">{userName}</span>
                        <div className={status}>
                            {t(status)}
                        </div>
                    </div>
                    <div className="user-avatar">
                        <img alt="avatar" src={userAvatar}/>
                    </div>
                </div>
                {languageSelectorComponent &&
                <div className="dropdown-menu-space">
                    {languageSelectorComponent}
                </div>
                }
            </div>
        </div>
    )
};

